<template>
  <div class="GJHome">
    <div>
      <GJHeader></GJHeader>
      <router-view/>
    </div>
    <div>
      <Footer></Footer>
    </div>
    <loading v-show="loading"></loading>
    <LogAndReg ref="logAndReg" v-show="loginPop"></LogAndReg>
  </div>
</template>

<script>
import Loading from "base/loading/loading";
import Footer from "base/footer/GJPageFooter";
import GJHeader from "base/header/GJHeader";
import LogAndReg from "views/pc/login/LogAndReg";
import { mapGetters } from "vuex";
export default {
    name: 'GJHome',
    computed: {
        ...mapGetters([
            'loading',
            'loginPop',
            'domainlist'
        ])
    },
    data() {
        return {}
    },
    mounted() {},
    components: {
        GJHeader,
        Loading,
        Footer,
        LogAndReg
    }
}
</script>

<style lang="scss" type="text/scss">
@import url("../common/scss/common.scss");
.GJHome {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.el-message__icon{
  font-size: 14px;
}
</style>
